import ApiService from "@/common/api/api.service";

export const CheckoutService = {


    // list() {
    //     ApiService.setHeader()
    //     return ApiService.get(`services/simple`)
    // },
    search(page=1, itemsPerPage=10, status=0, search="", orderBy = "", sortDesc = "", startDate = "", endDate = "") {
        ApiService.setHeader()
        return ApiService.get(`checkouts?page=${page}&itemsPerPage=${itemsPerPage}&status=${status}&search=${search}&orderBy=${orderBy}&sortDesc=${sortDesc}&startDate=${startDate}&endDate=${endDate}`)
    },
    listStatus() {
        ApiService.setHeader()
        return ApiService.get(`checkouts/status`)
    },

    get(personID, scheduleID) {
        ApiService.setHeader()
        return ApiService.get(`checkouts/${personID}/${scheduleID}`)
    },
    getSchedules(slug, page=1, itemsPerPage=1, orderBy="", sortDesc="") {
        ApiService.setHeader()
        return ApiService.get(`checkouts/${slug}?page=${page}&itemsPerPage=${itemsPerPage}&orderBy=${orderBy}&sortDesc=${sortDesc}`)
    },
    checkoutCharge(id, data) {
        ApiService.setHeader()
        return ApiService.post(`checkouts/${id}/charge`, data)
    },
    
    // create(data) {
    //     ApiService.setHeader()
    //     return ApiService.post('services', data)
    // },
    // update(slug, data) {
    //     ApiService.setHeader()
    //     return ApiService.update('services', slug, data)
    // },
    // active(id) {
    //     ApiService.setHeader()
    //     return ApiService.update(`services/${id}/active`)
    // },
    // inactive(id) {
    //     ApiService.setHeader()
    //     return ApiService.update(`services/${id}/inactive`)
    // },

    delete(personID, scheduleID) {
        ApiService.setHeader()
        return ApiService.delete(`checkouts/${personID}/${scheduleID}`)
    }
}